const StatusValue = ({
  value,
  className,
}: {
  value:
    | "failed"
    | "completed"
    | "pending"
    | "refunded"
    | "purchased"
    | "available"
    | "successful"
    | "active"
    | "used"
    | "success"
    | "withdrawal"
    | "deposit"
    | string;
  className?: string;
}) => {
  const getStatusStyles = (
    status:
      | "failed"
      | "completed"
      | "pending"
      | "refunded"
      | "purchased"
      | "available"
      | "successful"
      | "active"
      | "used"
      | "success"
      | "withdrawal"
      | "deposit"
      | string,
  ) => {
    switch (status) {
      case "failed":
        return "bg-[#FDE8E8] text-[#9B1C1C]";
      case "withdrawal":
        return "bg-[#FDE8E8] text-[#9B1C1C]";
      case "refunded":
        return "bg-[#FDE8E8] text-[#9B1C1C]";
      case "used":
        return "bg-[#FDE8E8] text-[#9B1C1C]";
      case "completed":
        return "bg-[#DEF7EC] text-[#03543F]";
      case "pending":
        return "bg-[#FDF6B2] text-[#723B13]";
      case "available":
        return "bg-[#DEF7EC] text-[#03543F]";
      case "successful":
        return "bg-[#DEF7EC] text-[#03543F]";
      case "success":
        return "bg-[#DEF7EC] text-[#03543F]";
      case "deposit":
        return "bg-[#DEF7EC] text-[#03543F]";
      case "active":
        return "bg-[#DEF7EC] text-[#03543F]";
      case "purchased":
        return "bg-[#FFF1DA] text-[#723B13]";
      default:
        return "";
    }
  };

  return (
    <div
      className={`w-[80px] flex items-center justify-center py-[2px] rounded-[5px] capitalize ${getStatusStyles(
        value,
      )} font-[400] text-[12px] ${className}`}
    >
      {value}
    </div>
  );
};

export default StatusValue;
